import React from 'react'
import Layout from '../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ElectronicCrockMeter = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2FTextileTesting%2Fimg%2F2.png?alt=media&token=8a0c4c9d-100f-45c5-a722-1a52e6dac835',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2FTextileTesting%2Fimg%2F3.png?alt=media&token=8a0c4c9d-100f-45c5-a722-1a52e6dac835'
    ];

    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/textile">Textile</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Electronic Crock Meter / Manual Crock Meter</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Electronic Crock Meter / Manual Crock Meter</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    To conduct the test, the specimen is clamped on a fixed seat of abrasion and a 5cm x 5cm white cloth is wrapped on the rub-hammer above the specimen. The abrasion hammer diameter is 16mm, centre load is 900g, and abrasion distance is 10cm, with one back-and-forth stroke each second for a total of 10 travels. The white cotton cloth is then compared using a gray scale to determine the decolorization level. Conforms to Standards: JIS L0849, ISO 105, AATCC 8. Applicable Industry: Textile, Leather.
                                    <br /><br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Electronic Crock Meter / Manual Crock Meter"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
            <br /><br /><br /><br />
        </Layout>
    )
}

export default ElectronicCrockMeter
